import { Cable } from "./Cable";
import { FeedbackType } from "./FeedbackType";
import { MFG } from "./MFG";

export class Drive {
  public constructor() {
    this.Series = "";
    this.MFGRowPointer = "";
    this.ContCurrent = 0.0;
    this.PeakCurrent = 0.0;
    this.MinOutputCurrent = 0.0;
    this.MaxOutputCurrent = 0.0;
    this.MaxInputVoltage = 0.0;
    this.FeedbackType = "";
    this.FeedbackTypes = [];
    this.MotorCode = "";
    this.Cable = new Cable();
    this.MFG = new MFG();
    this.RowPointer = "";
    this.CreateDate = new Date();
    this.RecordDate = new Date();
    this.CreatedBy = "";
    this.UpdatedBy = "";
  }

  public Series: string;
  public MFG: MFG;
  public MFGRowPointer: string;
  public ContCurrent: number;
  public PeakCurrent: number;
  public MinOutputCurrent: number;
  public MaxOutputCurrent: number;
  public MaxInputVoltage: number;
  public FeedbackType: string;
  public FeedbackTypes: FeedbackType[];
  public Cable: Cable;
  public MotorCode: string;

  //Syteline fields
  public RowPointer: string;
  public CreateDate: Date;
  public RecordDate: Date;
  public CreatedBy: string;
  public UpdatedBy: string;
}
